import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Layout from "./components/Layout";
import Root from "./routes";
import { Provider } from "mobx-react";

import Store from "./stores/userStore";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertMUITemplate from "react-alert-template-mui";

const options = {
  position: positions.MIDDLE,
};
function App() {
  return (
    <Provider>
      <AlertProvider template={AlertMUITemplate} {...options}>
        <Root />
      </AlertProvider>
    </Provider>
  );
}

export default App;
